/**
 * Charts API endpoints
 */
import type {
 ApiResponse,
 ApiListResponse,
 Chart,
 ChartInput,
 ChartUpdate,
} from "../lib/types";
import { authenticatedRequest } from "../lib/api";

export async function getCharts(token: string): Promise<Chart[]> {
 return authenticatedRequest<ApiListResponse<Chart>>("/api/charts", token).then(
  (res) => res.data
 );
}

export async function getChart(token: string, id: string): Promise<Chart> {
 return authenticatedRequest<ApiResponse<Chart>>(
  `/api/charts/${id}`,
  token
 ).then((res) => res.data);
}

export async function createChart(
 token: string,
 input: ChartInput
): Promise<Chart> {
 return authenticatedRequest<ApiResponse<Chart>>("/api/charts", token, {
  method: "POST",
  body: JSON.stringify(input),
 }).then((res) => res.data);
}

export async function updateChart(
 token: string,
 id: string,
 input: ChartUpdate
): Promise<Chart> {
 return authenticatedRequest<ApiResponse<Chart>>(`/api/charts/${id}`, token, {
  method: "PUT",
  body: JSON.stringify(input),
 }).then((res) => res.data);
}

export async function deleteChart(token: string, id: string): Promise<void> {
 return authenticatedRequest<void>(`/api/charts/${id}`, token, {
  method: "DELETE",
 });
}

export async function getChartSchema(
 token: string
): Promise<{ [key: string]: unknown }> {
 return authenticatedRequest<ApiResponse<{ [key: string]: unknown }>>(
  "/api/charts/schema",
  token
 ).then((res) => res.data);
}
